import React from 'react'
import Inner from '../component/Innerbanner'
function Hoodies() {
  return (
    <div>
        <Inner name="Sweat & Hoodies" title="Home Sweat & Hoodies " />

    </div>
  )
}

export default Hoodies